import { useEffect } from 'react'
import { NEW_ITEMS } from './NewMenu'

const SECTIONS = [
  {
    title: 'Global',
    shortcuts: [
      { keys: ['⌘', 'K'], label: 'Open command palette' },
      { keys: ['?'], label: 'Show keyboard shortcuts' },
    ],
  },
  {
    title: 'Navigation',
    shortcuts: [
      { keys: ['G', 'H'], label: 'Go to Home' },
      { keys: ['G', 'M'], label: 'Go to Messages' },
      { keys: ['G', 'V'], label: 'Go to Reviews' },
      { keys: ['G', 'T'], label: 'Go to Timesheets' },
      { keys: ['G', 'C'], label: 'Go to All clients' },
      { keys: ['G', 'L'], label: 'Go to Leads' },
      { keys: ['G', 'N'], label: 'Go to Networking' },
      { keys: ['G', 'R'], label: 'Go to Proposals' },
      { keys: ['G', 'P'], label: 'Go to Projects' },
      { keys: ['G', 'I'], label: 'Go to Invoices' },
      { keys: ['['], label: 'Collapse or expand the sidebar' },
    ],
  },
  {
    // The + New menu's letters only work while it is open; listed so they can
    // be learned without opening it to read them.
    title: 'Create (with + New open)',
    shortcuts: NEW_ITEMS.map(i => ({ keys: [i.key], label: `New ${i.label.toLowerCase()}` })),
  },
  {
    title: 'Actions',
    shortcuts: [
      { keys: ['Esc'], label: 'Close panel / modal' },
    ],
  },
]

function Key({ children }) {
  return (
    <kbd style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      minWidth: 22, height: 22, padding: '0 6px',
      background: 'var(--off)', border: '1px solid var(--bdr2)',
      borderBottom: '2px solid var(--bdr2)',
      borderRadius: 5, fontFamily: 'var(--fu)', fontSize: 11, fontWeight: 600,
      color: 'var(--navy)', lineHeight: 1,
    }}>
      {children}
    </kbd>
  )
}

export default function ShortcutsModal({ onClose }) {
  useEffect(() => {
    function onKey(e) {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }} onClick={onClose}>
      <div style={{
        background: 'var(--card)', borderRadius: 14, width: 440, maxWidth: '90vw',
        boxShadow: '0 24px 80px rgba(0,0,0,0.18)', overflow: 'hidden',
      }} onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div style={{ padding: '18px 20px 14px', borderBottom: '1px solid var(--bdr)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontFamily: 'var(--fd)', fontSize: 15, fontWeight: 700, color: 'var(--navy)' }}>Keyboard Shortcuts</span>
          <button onClick={onClose} style={{ width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--off)', border: 'none', borderRadius: 7, cursor: 'pointer', fontFamily: 'var(--fu)', fontSize: 16, color: 'var(--hint)' }}>×</button>
        </div>

        {/* Sections */}
        <div style={{ padding: '10px 20px 20px', maxHeight: '70vh', overflowY: 'auto' }}>
          {SECTIONS.map(section => (
            <div key={section.title} style={{ marginTop: 16 }}>
              <div style={{ fontFamily: 'var(--fu)', fontSize: 9, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--hint)', marginBottom: 8 }}>
                {section.title}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {section.shortcuts.map((s, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '7px 10px', borderRadius: 7, background: i % 2 === 0 ? 'var(--off)' : 'transparent' }}>
                    <span style={{ fontFamily: 'var(--fu)', fontSize: 12, color: 'var(--txt)' }}>{s.label}</span>
                    <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                      {s.keys.map((k, ki) => (
                        <Key key={ki}>{k}</Key>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div style={{ padding: '10px 20px 16px', borderTop: '1px solid var(--bdr)', textAlign: 'center' }}>
          <span style={{ fontFamily: 'var(--fu)', fontSize: 10, color: 'var(--hint)' }}>Press <Key>?</Key> or <Key>Esc</Key> to dismiss</span>
        </div>
      </div>
    </div>
  )
}
